export class IntegrationStates {
    static readonly GMAIL_STATE = `gmailcentilyticsintegrate`;
    static readonly SLACK_STATE = `slackcentilyticsintegrate`;
    static readonly O365_STATE = `o365centilyticsintegrate`;
    static readonly TEAMS_STATE = `o365centilyticsintegrate`;
    static readonly ZOHO_STATE = `zohocentilyticsintegrate`;
    static readonly ZOHO_STATE_UPDATE = `zohocentilyticsupdate`;
}
